import React from 'react';
import { useAppState } from '../../state/AppState';

const UserAvatar = ({
  size = 128,
  src,
  style = {},
}: {
  size?: number;
  src?: string | null | undefined;
  style?: React.CSSProperties;
}) => {
  const { user } = useAppState();
  return (
    <img
      alt='avatar'
      className='user-avatar'
      width={size}
      height={size}
      style={style}
      src={src || user?.avatarUrl || user?.photoURL}></img>
  );
};

export default UserAvatar;
